import React from 'react';

export function sameType(node, type) {
  return React.isValidElement(node) && (node.type === type);
}

export function hasComponentWithType(children, type) {
  let found = false;
  React.Children.forEach(children, (child) => {
    if (found) return;
    if (sameType(child, type)) {
      found = true;
    } else if (child.props.children) {
      found = hasComponentWithType(child.props.children, type);
    }
  });
  return found;
}
